import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoadingService } from './services/loading.service';

const SILENT_URL_PATTERNS = [
  '/auth/refresh',
  '/client/GetMenuCodes',
  '/client/GetClientLicenses',
  '/client/GetClientSubscription',
  '/client/GetClientDetail',
  '/client/PageDefaultSetting',
  '/Dashboard/',
  '/Notification/List',
  '/Notification/UnreadCount',
  '/hubs/notifications',
  '/PushDevice/'
];

function shouldSuppressLoader(url: string): boolean {
  return SILENT_URL_PATTERNS.some((pattern) => url.includes(pattern));
}

export const LoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  if (shouldSuppressLoader(req.url)) {
    return next(req);
  }

  loadingService.show();

  return next(req).pipe(
    finalize(() => loadingService.hide())
  );
};
